import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { TAB_4B_RESET_HELP_BLOCK } from "actions";

const HelpBlockTab4B = props => {
  const { helpBlockTab4BIsOpen, domain } = props;
  return (
    <div className={classNames("right_slide_block invoice_slide_help", { opnd: helpBlockTab4BIsOpen })}>
      <div className="right_slide_block--inner">
        <div className="auto_fill_slide--content">
          <h2>{domain.Strings.helpBlock4BTitle}</h2>
          <p>{domain.Strings.helpBlock4BSubTitle}</p>
          <p>
            <strong>{domain.Strings.helpBlock4BSalesLabel}</strong>
            {domain.Strings.helpBlock4BSalesExtra}
          </p>
          <p>
            <strong>{domain.Strings.helpBlock4BBadDebtsLabel}</strong>
            {domain.Strings.helpBlock4BBadDebtsExtra}
          </p>
          <p>
            <strong>{domain.Strings.helpBlock4BLargestDebtLabel}</strong>
            {domain.Strings.helpBlock4BLargestDebtExtra}
          </p>
          <div>
            <a onClick={props.hide} className="back_btn">
              {domain.Strings.helpBlock4BBackBtn}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = dispatch => {
  return {
    hide: () => dispatch({ type: TAB_4B_RESET_HELP_BLOCK })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HelpBlockTab4B);
